import { useState } from 'react'
import styles from './LocationAutoCompleteInput.module.css'
import { Options } from './Options'
import classNames from 'classnames'
import Popper from '@mui/material/Popper'

interface LocationAutoCompleteInputProps{
    location: any
    text: string
    ref: any,
    error?: any,
    options?: any,
    isLoading?: boolean
    isOptionsLoading?: boolean
    isOptionsOpen?: boolean
    onInput?: (event: any) => void
    onFocus?: (event: any) => void
    onLocationChange?: (event: any) => void
}

export const LocationAutoCompleteInput = (props: LocationAutoCompleteInputProps): JSX.Element => {
    const {
        location,
        text,
        ref,
        error = null,
        options = null,
        isLoading = false,
        isOptionsLoading = false,
        isOptionsOpen = false,
        onInput,
        onFocus,
        onLocationChange
    } = props

    const [inputRef, setInputRef] = useState<HTMLElement | null>(null)

    const handleInputInput = (event: any) => {
        onInput?.(event.target.value)
    }

    const handleOptionsItemClick = (event: any) => {
        onLocationChange?.(event)
    }

    const handleInputRef = (event: any) => {
        setInputRef(event)
    }

    const handleInputFocus = (event: any) => {
        onFocus?.(event)
    }

    const autocompleteInputClasses = classNames(styles.AutocompleteInput, {
        [styles[`AutocompleteInput--Error`]]: error !== null,
    })

    const sameWidth = {
        name: "sameWidth",
        enabled: true,
        phase: "beforeWrite",
        requires: ["computeStyles"],
        fn: ({ state }: any) => {
            state.styles.popper.width = `${state.rects.reference.width}px`;
        },
        effect: ({ state }: any) => {
            state.elements.popper.style.width = `${
            state.elements.reference.offsetWidth
            }px`;
        }
    }

    const popperOptions: any | undefined = {
        placement: `bottom-start`,
        modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 10],
                    },
                },
                sameWidth
            ]
    }

    return (
        <div className={autocompleteInputClasses}>
            <div className={styles.AutocompleteInput__InputWrapper}>
                <input 
                    className={styles.AutocompleteInput__Input}
                    ref={handleInputRef}
                    value={text}
                    onInput={handleInputInput}
                    onFocus={handleInputFocus}
                />
            </div>   
            <Popper
                className={styles.AutocompleteInput__Popper}
                open={isOptionsOpen}
                anchorEl={inputRef}
                popperOptions={popperOptions}
            >
                <Options 
                    isLoading={isOptionsLoading}
                    optionsOpen={isOptionsOpen}
                    error={error}
                    options={options}
                    onOptionClick={handleOptionsItemClick}
                />
            </Popper>


        </div>
    )
}